import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    startUrl: String,
    finishUrl: String,
    detectPatterns: Array,
    cookieDomains: Array,
  };

  connect() {
    const data = {
      startUrl: this.startUrlValue,
      finishUrl: this.finishUrlValue,
      detectPatterns: this.detectPatternsValue,
      cookieDomains: this.cookieDomainsValue,
    };

    this.presentSso(data);
  }

  presentSso(data = {}) {
    try {
      if (typeof androidApp !== "undefined") {
        androidApp.presentSso(data.startUrl, data.finishUrl, data.detectPatterns, data.cookieDomains);
      } else if (typeof webkit !== "undefined" && typeof webkit.messageHandlers !== "undefined") {
        webkit.messageHandlers.presentSso.postMessage(data);
      } else {
        console.log("presentSso not found", data);
      }
    } catch (error) {
      console.error("PresentSsoController: ", error, data);
    }
  }
}
